import { find } from 'lodash';
import type { ProductPayload } from '../interfaces';

export const hasPaidProductSelected = (values: ProductPayload[]) => !!find(values, (value) => {
  if (value.minimumPrice === 0) {
    return false;
  }

  if (!value.hasVariablePrice && value.quantity > 0) {
    return true;
  }

  return value.quantity && (value.ticketPrice || value.minimumPrice);
});
